import { Signal } from 'signal-polyfill';
import type { EntrySummaryDto, EntryStatus, PdfStatus } from '../../../api/types';

export interface ListState {
  entries: EntrySummaryDto[];
  page: number;
  pageSize: number;
  total: number;
  loading: boolean;
  filters: {
    trialId: string | null;
    status: EntryStatus | 'All';
    pdfStatus: PdfStatus | 'All';
    search: string;
  };
}

const initialListState: ListState = {
  entries: [],
  page: 1,
  pageSize: 10,
  total: 0,
  loading: false,
  filters: {
    trialId: null,
    status: 'All',
    pdfStatus: 'All',
    search: '',
  },
};

export const listState = new Signal.State<ListState>(initialListState);

export const totalPages = new Signal.Computed(() => {
  const state = listState.get();
  const pages = Math.ceil(state.total / state.pageSize);
  return pages > 0 ? pages : 1;
});

export const listActions = {
  reset(): void {
    listState.set(initialListState);
  },

  setLoading(loading: boolean): void {
    listState.set({ ...listState.get(), loading });
  },

  setEntries(entries: EntrySummaryDto[], total: number, page?: number, pageSize?: number): void {
    const state = listState.get();
    listState.set({
      ...state,
      entries,
      total,
      page: page ?? state.page,
      pageSize: pageSize ?? state.pageSize,
    });
  },

  setPage(page: number): void {
    listState.set({ ...listState.get(), page });
  },

  setPageSize(pageSize: number): void {
    listState.set({ ...listState.get(), pageSize, page: 1 });
  },

  setFilters(filters: Partial<ListState['filters']>): void {
    const state = listState.get();
    listState.set({
      ...state,
      page: 1,
      filters: {
        ...state.filters,
        ...filters,
      },
    });
  },
};
